import { Observable } from 'rxjs';

export const EFFECT = Symbol('EFFECT');

/*
 **-------------------------------------------------------------------------------------
 ** METHOD NAME - createEffect
 **-------------------------------------------------------------------------------------
 */
export function createEffect<T>(source: () => Observable<T> | void) {
	Object.defineProperty(source, EFFECT, { value: true });

	return source;
}
